import { api } from '@/api';
import type {
  AdminBilling,
  Catalog,
  InstitutionBillingDetail,
  InstitutionSignupInput,
  PlanChoice,
  Quote,
  SignupResult,
  SimulatedInvoice,
} from './types';

// Public: the plans page works signed out.
export const getCatalog = (signal?: AbortSignal) =>
  api.get<Catalog>('/billing/plans', { signal, auth: false });
export const getQuote = (choice: PlanChoice, signal?: AbortSignal) =>
  api.post<Quote>('/billing/quote', choice, { signal, auth: false });

/** An IES signs up: the signed-in person becomes its coordinator. */
export const signUpInstitution = (input: InstitutionSignupInput) =>
  api.post<SignupResult>('/billing/institutions', input, { timeoutMs: 60_000 });

// The coordination.
export const getMyBilling = (signal?: AbortSignal) =>
  api.get<InstitutionBillingDetail[]>('/billing/my', { signal });
export const subscribe = (institutionId: string, choice: PlanChoice) =>
  api.post<SignupResult>(`/billing/institutions/${institutionId}/subscribe`, choice, {
    timeoutMs: 60_000,
  });
export const cancelOwnPlan = (institutionId: string, reason: string) =>
  api.post<InstitutionBillingDetail>(`/billing/institutions/${institutionId}/cancel`, { reason });

// The administration.
export const getAdminBilling = (signal?: AbortSignal) =>
  api.get<AdminBilling>('/admin/billing', { signal });
export const getAdminInstitutionBilling = (id: string, signal?: AbortSignal) =>
  api.get<InstitutionBillingDetail>(`/admin/billing/institutions/${id}`, { signal });
export const grantCourtesy = (
  id: string,
  input: { plan: string; seats: number | null; until: string | null; reason: string },
) => api.post<InstitutionBillingDetail>(`/admin/billing/institutions/${id}/courtesy`, input);
export const endCourtesy = (id: string, input: { on: string | null; reason: string }) =>
  api.post<InstitutionBillingDetail>(`/admin/billing/institutions/${id}/courtesy/end`, input);
export const cancelPlan = (id: string, input: { reason: string; immediate: boolean }) =>
  api.post<InstitutionBillingDetail>(`/admin/billing/institutions/${id}/cancel`, input, {
    timeoutMs: 60_000,
  });
export const blockInstitution = (id: string, reason: string) =>
  api.post<InstitutionBillingDetail>(`/admin/billing/institutions/${id}/block`, { reason });
export const unblockInstitution = (id: string) =>
  api.post<InstitutionBillingDetail>(`/admin/billing/institutions/${id}/unblock`);

// Simulated Asaas (no API key): the invoice page.
export const getSimulatedInvoice = (id: string, signal?: AbortSignal) =>
  api.get<SimulatedInvoice>(`/billing/simulated/${id}`, { signal, auth: false });
export const paySimulatedInvoice = (id: string) =>
  api.post<SimulatedInvoice>(`/billing/simulated/${id}/pay`, undefined, { auth: false });
